import type { MoveList } from 'chessboard/model/move-list/types';
import type { MoveListComponent } from 'components/move-list/config/types';
import type { NodeLimits } from 'components/move-list/store/types';

export namespace MoveListPlugin {
  export interface API {
    enableNodeLimits: () => void;
    updateNodeLimits: (nodeLimits: NodeLimits) => void;
    setCommentsEditable: (editable: boolean) => void;
    activate: () => void;
    deactivate: () => void;
    getMoveList: () => MoveListComponent.API;
  }

  export enum Events {
    Ready = 'Ready',
    Updated = 'Updated',
  }

  export interface Options {
    target: HTMLElement;
    scrollContainer?: HTMLElement;
    translations?: MoveList.Translations;
    displayTimeInClockFormat?: boolean;
    hideTimestampText?: boolean;
    showTimestamps?: boolean;
    loadLineOnCreate?: boolean;
    customColorsEnabled?: boolean;
  }

  export const Name = 'move-list';
}
